import React, {useState} from "react"
import "./UnitGroupFloorSelector.scss"
import {publishEvent} from "../../util/publishEvent";
import {FloorSelected, FloorSelectorDrawerOpen} from "../../constants";
import {IUnitGroup} from "../../interfaces/IUnitGroup";
import {IFloorSelectorDrawerEvent} from "./IFloorSelectorDrawerEvent";
import {useLocalStorage} from "usehooks-ts";
import {IconArrow} from "../../icons";
import {useEvent} from "../../hooks/useEvent";
import {IFloorSelectedEvent} from "./IFloorSelectedEvent";

export function UnitGroupFloorSelector(p:{unitGroup:IUnitGroup,currency:string}) {

  const [lsFloor, setLsFloor] = useLocalStorage<number>("storefront-floor-selector-"+p.unitGroup.id,0)

  const [floor, setFloor] = useState<number>(lsFloor)

  const minFloor = Math.min(...p.unitGroup.units.map(u => u.floor))
  const maxFloor = Math.max(...p.unitGroup.units.map(u => u.floor))

  const onclick = () => {
    publishEvent<IFloorSelectorDrawerEvent>(FloorSelectorDrawerOpen,{unitGroup:p.unitGroup, currency:p.currency})
  }

  useEvent<IFloorSelectedEvent>(FloorSelected, data => {
    if(data.unit_group_id === p.unitGroup.id) {
      setFloor(data.floor)
      setLsFloor(data.floor)
    }
  })

  return <div className="UnitGroupFloorSelector" onClick={onclick}>
    <strong>
      {
        floor > 0
          ?
          <span>{floor}-й поверх</span>
          :
          <span>Оберіть поверх {minFloor}-{maxFloor}</span>
      }
      <IconArrow/>
    </strong>
    <span>В продажу: {p.unitGroup.units.length}шт</span>
  </div>
}